/* eslint-disable no-restricted-properties */
import { isInteger, slice, round, isFinite, isNil } from 'lodash';

import { formatNumber } from 'libphonenumber-js';

function install(Vue) {
  Vue.filter('limit-by-state', (array, limit, active) => {
    const end = active ? array.lenght : limit;
    return slice(array, 0, end);
  });


  Vue.filter('reverse', value => value.split('').reverse().join(''));

  Vue.filter('format-time', (time) => {
    let formatedTime = '';
    if (time === undefined || time === null || time === '') return formatedTime;
    if (time.indexOf(':') !== -1) {
      const tmp = time.split(':');
      if (tmp.length > 2) formatedTime = `${tmp[0]}:${tmp[1]}`;
    }
    return formatedTime;
  });

  Vue.filter('split-by-comma', (value, type) => {
    type = type || 'title';
    let text = '';
    const index = value.indexOf(',');
    if (type === 'title') {
      if (index !== -1) {
        const title = value.substring(0, index);
        text = title;
      } else {
        text = value;
      }
    } else if (index !== -1) {
      const subTitle = value.substring(index + 1);
      text = subTitle;
    }
    return text.trim();
  });

  Vue.filter('first-two-upper', (text) => {
    let towUpper = '';
    let tmp;

    if (text === undefined || text === null || text === '') return towUpper;

    if (text.indexOf(' ') !== -1) {
      tmp = text.replace(/,/g, '').split(' ');

      const first = tmp[0].replace(/[^0-9a-z]/gi, '').substring(0, 1).toUpperCase();
      const second = tmp[1].replace(/[^0-9a-z]/gi, '').substring(0, 1).toUpperCase();

      towUpper = first + second;
    } else {
      towUpper = text.substring(0, 2).toUpperCase();
    }

    return towUpper;
  });

  Vue.filter('first-upper', (text) => {
    if (text === undefined || text === null || text === '') return '';
    return text.substring(0, 1).toUpperCase();
  });

  Vue.filter('lowercase', (text) => {
    if (text === undefined || text === null || text === '') return '';
    return text.toLowerCase();
  });

  Vue.filter('uppercase', (text) => {
    if (text === undefined || text === null || text === '') return '';
    return text.toUpperCase();
  });

  Vue.filter('title-case', (text) => {
    if (text === undefined || text === null || text === '') return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  });

  Vue.filter('first-string', (text, number = 3, end = '.') => {
    if (text === undefined || text === null || text === '') return '';
    return text.substring(0, number) + end;
  });

  Vue.filter('slice', (text, length = 50, extension = '...') => {
    text = text ? text.trim() : '';
    if (text.length <= length) return text;
    let sliced = text.length > length ? text.slice(0, length).trim() : text;
    const lastString = sliced.substr(sliced.length - 1);
    if (lastString === ',' || lastString === '.') sliced = sliced.slice(0, sliced.length - 1);
    return sliced + extension;
  });

  // Vue.filter('number-format', (value, decimals, condRound, force = false, decPoint, thousandsSep) => {
  //   // *     example 1: number_format(1234.56);
  //   // *     returns 1: '1,235'
  //   // *     example 2: number_format(1234.56, 2, ',', ' ');
  //   // *     returns 2: '1 234,56'
  //   // *     example 3: number_format(1234.5678, 2, '.', '');
  //   // *     returns 3: '1234.57'
  //   // *     example 4: number_format(67, 2, ',', '.');
  //   // *     returns 4: '67,00'
  //   // *     example 5: number_format(1000);
  //   // *     returns 5: '1,000'
  //   // *     example 6: number_format(67.311, 2);
  //   // *     returns 6: '67.31'
  //   // *     example 7: number_format(1000.55, 1);
  //   // *     returns 7: '1,000.6'
  //   // *     example 8: number_format(67000, 5, ',', '.');
  //   // *     returns 8: '67.000,00000'
  //   // *     example 9: number_format(0.9, 0);
  //   // *     returns 9: '1'
  //   // *    example 10: number_format('1.20', 2);
  //   // *    returns 10: '1.20'
  //   // *    example 11: number_format('1.20', 4);
  //   // *    returns 11: '1.2000'
  //   // *    example 12: number_format('1.2000', 3);
  //   // *    returns 12: '1.200'

  //   function toFixedFix(n, prec) {
  //     // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  //     const k = Math.pow(10, prec);
  //     return Math.round(n * k) / k;
  //   }

  //   const number = Number(value);

  //   // if not set take 3 decimals
  //   decimals = isNumber(decimals) ? decimals : 1;

  //   if (condRound) {
  //     if (number < condRound) decimals = 2;
  //     else decimals = 1;
  //   }

  //   // special case for integer, no decimals!
  //   if (isInteger(number) && !force) decimals = 0;

  //   const n = !isFinite(+number) ? 0 : +number;
  //   const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  //   const sep = (typeof thousandsSep === 'undefined') ? '' : thousandsSep;
  //   const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;

  //   const s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');

  //   if (s[0].length > 3) {
  //     s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  //   }

  //   if ((s[1] || '').length < prec) {
  //     s[1] = s[1] || '';
  //     s[1] += new Array((prec - s[1].length) + 1).join('0');
  //   }

  //   return s.join(dec);
  // });

  Vue.filter('number-format', (value, decimals, condRound, force = false, notNumber = '~') => {
    if (!isNil(value) && value === '') return notNumber;

    const number = Number(value);
    const dec = Number(decimals);

    if (!isFinite(number)) return notNumber;

    let decToRound = isFinite(dec) ? dec : 1;

    if (isInteger(number)) decToRound = 0;

    if (condRound) {
      if (number < Number(condRound)) decToRound = 2;
      else decToRound = 1;
    }

    if (force) decToRound = dec;

    return round(number, decToRound);
  });

  Vue.filter('sufix-if-number', (value, sufix) => (isFinite(Number(value)) ? `${value}${sufix}` : value));

  Vue.filter('phone', value => (value ? formatNumber(value, 'International') : ''));
}


export default install;



// WEBPACK FOOTER //
// ./src/filters/index.js